import React from 'react';
import CommentList from './CommentList';

export default function CommentModal({ isOpen, onClose, transactionId, transactionType, transactionDescription, transactionAmount, onCommentsChange }) {
    if (!isOpen) return null;
    
    return (
        <>
            {/* Backdrop */}
            <div
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                    animation: 'fadeIn 0.2s ease-in'
                }}
            />
            
            {/* Modal */}
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
                    zIndex: 1001,
                    width: '90%',
                    maxWidth: '600px',
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    animation: 'slideIn 0.3s ease-out',
                    direction: 'rtl'
                }}
            >
                {/* Header */}
                <div style={{
                    padding: '20px',
                    borderBottom: '1px solid #E0E0E0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '20px' }}>💬</span>
                        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#333' }}>
                            הערות לעסקה
                        </h3>
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#999',
                            padding: '0',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#F5F5F5';
                            e.target.style.color = '#333';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#999';
                        }}
                    >
                        ×
                    </button>
                </div>
                
                {/* Business name */}
                <div style={{
                    padding: '12px 20px',
                    backgroundColor: '#F8F9FA',
                    borderBottom: '1px solid #E0E0E0'
                }}>
                    <p style={{ margin: 0, fontSize: '15px', color: '#333', fontWeight: '500' }}>
                        {transactionDescription}
                    </p>
                </div>
                
                {/* Content */}
                <div style={{
                    padding: '20px',
                    overflowY: 'auto',
                    flex: 1
                }}>
                    <CommentList
                        transactionId={transactionId}
                        transactionType={transactionType}
                        transactionDescription={transactionDescription}
                        transactionAmount={transactionAmount}
                        compact={false}
                        showHeader={false}
                        onCommentsChange={onCommentsChange}
                    />
                </div>
            </div>
            
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translate(-50%, -45%);
                    }
                    to {
                        opacity: 1;
                        transform: translate(-50%, -50%);
                    }
                }
            `}</style>
        </>
    );
}